<template>
    <div id="viewerContainer">
    </div>
</template>
<style>
    #viewerContainer {
        background-color: #e5e5e5;
        height: 109vh;
    }
</style>
<script lang="js">
import Vue from "vue";
import { env } from '@/environment/environment';
import { api } from '@/services/api';
import { createViewer } from "@mescius/activereportsnet-viewer";
import "@mescius/activereportsnet-viewer/dist/jsViewer.min.css";

export default Vue.extend({
  name: "Viewer",
  props: ['reportName', 'dataUrl', 'reportParams', 'printOnly'],        
  data: function() {
    return {
        viewer: null,
        reportToken: null,
        componentDestroyed: false,
        openReportPending: false,
    };
  },
  methods: {
    apiUrl: function() {
      return env.VUE_APP_API_URL.replace(/\/+$/, '');
    },
    printReport: function() {
      if (this.viewer) this.viewer.print();
    },
    exportToCsv: function() {
      if (this.viewer) this.viewer.export('CsvData', null, true, {PrintOnOpen: 'true'});
    },
    exportToPdf: function(fileName) { 
      if (!this.viewer) return;
      this.viewer.export('Pdf', function (uri) {
                var newWin = null;
                try {
                    newWin = window.open(uri);
                } catch (e) {
                    // Some browsers reject popups; same-window navigation below is the fallback.
                }
                if (!newWin) {
                    window.location = uri;
                }},
                false, 
                { FileName: `${fileName}.pdf` }
          );
    },
    handleViewerError: function(error) {
      if (error.severity && error.severity !== 'error') return false;

      const message = [error.message, error.details].filter(Boolean).join(': ');
      const viewerError = new Error(message || 'ActiveReports viewer error');
      viewerError.name = 'ActiveReportsError';
      this.$handleError(viewerError);
      return true;
    },
    openReport: function () {
      if (!this.viewer || !this.reportToken) return;

      if(this.printOnly) {
        this.viewer.sidebar.toggle(false);
      }

      const separator = this.dataUrl.includes('?') ? '&' : '?';
      let params = [
          { name: 'API_URL', values: [`${this.apiUrl()}${this.dataUrl}${separator}reportToken=${encodeURIComponent(this.reportToken)}`]},
        ];


      if(this.reportParams){
        params = params.concat(this.reportParams);
      }    
      this.viewer.openReport(
        this.reportName,
        params
      );
    },
    scheduleOpenReport: function () {
      if (this.openReportPending) return;

      this.openReportPending = true;
      this.$nextTick(() => {
        this.openReportPending = false;
        this.openReport();
      });
    }
  },
  async mounted() {
      const { data } = await api.post('/reports/access-token');
      if (this.componentDestroyed) return;

      this.reportToken = data.token;
      const userToken = localStorage.getItem('userToken');
      this.viewer = createViewer({
        element: '#viewerContainer',
        availableExports: ["Pdf", "CsvData"],
        reportService: {
          url: `${this.apiUrl()}/api/reporting`,
          onRequest: (init) => {
            init.credentials = 'include';
            const headers = new Headers(init.headers);
            headers.set('Authorization', `Bearer ${userToken}`);
            init.headers = headers;
          }
        },
        error: this.handleViewerError,
      });

      this.openReport();
  },
  beforeDestroy() {
    this.componentDestroyed = true;
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
  },
  watch: {
    reportName() {
      this.scheduleOpenReport();
    },            
    dataUrl() {
      this.scheduleOpenReport();
    },            
    reportParams() {
      this.scheduleOpenReport();
    },    
  },  
});
</script>
